import React from 'react';
import { Shield, Clock, Recycle, Users, DollarSign, CheckCircle } from 'lucide-react';
import { features } from '../mock/mockData';

const iconMap = {
  Shield,
  Clock,
  Recycle,
  Users,
  DollarSign,
  CheckCircle
};

export const Features = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">Why Choose Space Specialists?</h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Professional, reliable, and eco-friendly garage cleanout services you can trust
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={index}
                className="group p-8 rounded-xl border border-slate-200 hover:border-blue-300 hover:shadow-lg transition-all duration-300 bg-white"
              >
                <div className="bg-blue-50 w-14 h-14 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-100 transition-colors">
                  <IconComponent className="h-7 w-7 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">{feature.title}</h3>
                <p className="text-slate-600 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
